module.exports = __webpack_public_path__ + "static/img/mobile_hwaq_bg_white.a49b400.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_hwaq_bg_white.png
// module id = w59I
// module chunks = 21